const {DATA_TYPES, NAMESPACE_MAPPING} = require('@wix/document-services-json-schemas').namespaceMapping
const {migrateMegaMenuContainerItemLayout} = require('./layout')
const dataUtils = require('../../../helpers/dataUtils')

const DROPDOWN_SKIN = 'wixui.skins.Dropdown'

/** @typedef {import('../types.js').MenuStyleProperties} MenuStyleProperties */

/**
 * @param {Object} pageManager
 * @param {Object} component
 * @param {MenuStyleProperties} MenuStyleProperties
 * @param {Array<string>} [variants]
 */
const migrateMegaMenuContainerItem = (pageManager, component, MenuStyleProperties, variants) => {
    const {components} = component

    if (components.length === 0) return

    components.forEach(MegaMenuContainerItemComponent => {
        const componentStyle = migrateToBreakpointsStyleIfNeeded(pageManager, MegaMenuContainerItemComponent)
        const styleItemPerBreakpoint = populateStylePerBreakpoint(pageManager)
        migrateMegaMenuContainerItemLayout(
            pageManager,
            MenuStyleProperties,
            styleItemPerBreakpoint.style.properties,
            component
        )
        const variantRelationId = populateVariantsRelationIfNeeded(
            pageManager,
            componentStyle.id,
            styleItemPerBreakpoint.id,
            variants
        )
        const styleIdToRefer = variantRelationId ?? styleItemPerBreakpoint.id
        pageManager.data.updateItem(componentStyle.id, NAMESPACE_MAPPING.style, {
            values: [...componentStyle.values, `#${styleIdToRefer}`]
        })
    })
}

/**
 * @param {Object} pageManager
 * @param {Object} component
 */
const migrateToBreakpointsStyleIfNeeded = (pageManager, component) => {
    const initialComponentStyle = pageManager.data.getItem(NAMESPACE_MAPPING.style, component.styleId)
    const isAlreadyBreakpointsStyle = initialComponentStyle.type === 'RefArray'

    if (isAlreadyBreakpointsStyle) return initialComponentStyle

    pageManager.data.removeItem(NAMESPACE_MAPPING.style, initialComponentStyle.id)
    const newComponentStyleId = pageManager.data.addItem(NAMESPACE_MAPPING.style, DATA_TYPES.theme, {
        id: initialComponentStyle.id,
        ...dataUtils.refArray.create()
    })
    const newComponentStyle = pageManager.data.getItem(NAMESPACE_MAPPING.style, newComponentStyleId)
    component.styleId = newComponentStyleId
    component.skin = DROPDOWN_SKIN

    return newComponentStyle
}

/**
 * @param {Object} pageManager
 * @param {string} MegaMenuContainerItemId
 * @param {string} styleId
 * @param {Array<string>} variants
 */
const populateVariantsRelationIfNeeded = (pageManager, MegaMenuContainerItemId, styleId, variants) => {
    if (!variants) return

    return pageManager.data.addItem(NAMESPACE_MAPPING.style, DATA_TYPES.theme, {
        to: `#${styleId}`,
        from: `#${MegaMenuContainerItemId}`,
        type: 'VariantRelation',
        variants
    })
}

/**
 * @param {Object} pageManager
 */
const populateStylePerBreakpoint = pageManager => {
    const styleIdPerBreakpoint = pageManager.data.addItem(NAMESPACE_MAPPING.style, DATA_TYPES.theme, {
        type: 'ComponentStyle',
        style: {
            properties: {},
            propertiesSource: {},
            groups: {}
        },
        componentClassName: 'wixui.MegaMenuContainerItem',
        styleType: 'custom',
        skin: DROPDOWN_SKIN
    })

    const styleItemPerBreakpoint = pageManager.data.getItem(NAMESPACE_MAPPING.style, styleIdPerBreakpoint)

    return styleItemPerBreakpoint
}

module.exports = {
    migrateMegaMenuContainerItem
}
